import React, { Component } from "react";
import "./form-steps.scss";
import "./../../modals/multi_step_modals/multi_step_modal.scss";
import { classNames } from "react-extras";
import range from "lodash/range";
import get from "lodash/get";
import { Col, Grid, Row } from "react-bootstrap";

export class FormStep extends Component {
  render() {
    const { step, currentStep, children } = this.props;

    let isVisible = false;
    if (Array.isArray(step)) {
      isVisible = step.includes(currentStep);
    } else {
      isVisible = step === currentStep;
    }

    return (
      <div className={classNames("form-step", !isVisible && "form-step--invisible")}>
        {children}
      </div>
    );
  }
}

// Same as MultiStepWithNavContent but using the FormStep component instead
export const FormStepWithNav = props => {
  const { children, setStep, currentStep, disableClickNav = false, hideMenuXS = false } = props;

  return (
    <div>
      <Grid fluid className="multistep-nav">
        <Row>
          <Col xsHidden={hideMenuXS} xs={12} sm={2}>
            <div className={"margin-bottom--large"}>
              {React.Children.map(children, child => {
                if (!child) return null;

                const step = get(child, ["props", "step"]);
                const navName = get(child, ["props", "navName"]);

                return (
                  <div
                    key={step}
                    className={classNames(
                      "multistep-nav-item",
                      currentStep === step && "active",
                      currentStep !== step && disableClickNav && "cursor-disabled inactive-dim"
                    )}
                    onClick={() => {
                      if (!disableClickNav) setStep(step);
                    }}>
                    {navName}
                  </div>
                );
              })}
            </div>
          </Col>
          <Col xs={12} md={8} mdOffset={1}>
            {React.Children.map(children, child => {
              if (!child) return null;
              return React.cloneElement(child);
            })}
          </Col>
        </Row>
      </Grid>
    </div>
  );
};

export class FormStepDots extends Component {
  getStyle = (index, total) => {
    switch (index) {
      case total:
        return { right: "0px" };
      case 1:
        return { left: "0px" };
      default:
        return { left: `calc(${Math.round(((index - 1) / (total - 1)) * 100)}% - 10px)` };
    }
  };
  render() {
    let { numSteps, currentStep } = this.props;
    let stepNumbers = range(1, numSteps + 1);

    return (
      <div className="form-step-dots">
        <div className="form-step-dots__line" />
        {stepNumbers.map(index => (
          <div
            className={classNames(
              "form-step-dots__dot",
              currentStep === index && "form-step-dots__dot--selected"
            )}
            style={this.getStyle(index, numSteps)}
            key={index}
          />
        ))}
      </div>
    );
  }
}
